import { Fragment, ReactNode } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';

import { cn } from 'support/helpers/cn/cn';

import { MenuAlignment, MenuButtonItem } from './types';

type HeaderMenuButtonProps = {
  trigger: ReactNode;
  items: Array<MenuButtonItem>;
  menuAlignment?: MenuAlignment;
};

export const HeaderMenuButton = ({ trigger, items, menuAlignment = 'right' }: HeaderMenuButtonProps) => {
  return (
    <div className="relative text-gray-600 focus-visible:outline-hidden">
      <Menu>
        <MenuButton className="flex w-full items-center focus-visible:outline-hidden">
          <div
            className={cn(
              'group text-left text-sm font-medium focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-100 focus-visible:outline-hidden',
            )}
          >
            {trigger}
          </div>
        </MenuButton>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems
            className={cn(
              'absolute z-500 mt-1 origin-top cursor-pointer overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus-visible:outline-hidden',
              menuAlignment === 'right' ? 'right-0' : 'left-0',
            )}
          >
            {items.map(({ value, onClick }) => (
              <MenuItem key={value}>
                <button className="w-36 text-left hover:bg-gray-200" onClick={onClick}>
                  <div className="px-4 py-2 text-sm text-gray-700">{value}</div>
                </button>
              </MenuItem>
            ))}
          </MenuItems>
        </Transition>
      </Menu>
    </div>
  );
};
